export enum ReportCreationTypeEnum {
  download,
  email
}
